import React from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import '../../../css/layout/cards/PricingPlanCards.css';

const CustomPlanCard = ({ auth: { isAuthenticated, user } }) => {
  const navigate = useNavigate();

  const handleScheduleCall = () => {
    if (!isAuthenticated) {
      // Save the intended URL to localStorage
      localStorage.setItem('redirectTo', '/contact-us');
      toast.info('Please log in to schedule a call.');
      navigate('/login'); // Redirect to login page
    } else {
      navigate('/contact-us'); // Redirect to the intended page
    }
  };

  return (
    <div className='custom-plan-card'>
      {/* Top Text */}
      <div>
        <p className='custom-card-top-text'>
          Looking for a custom solution to reach your <br /> goal?
        </p>
      </div>

      {/* Plan Name */}
      <h3 className='card-plan-name'>Custom Requirements</h3>

      {/* Price */}
      <div className='mt-6'>
        <p>
          <span className='custom-card-pricing-amount'>
            Talk <br />
            to us
          </span>
        </p>
      </div>

      {/* Buy Plan Button */}
      <div className='flex justify-center mt-7'>
        <button
          className='custom-card-buy-button px-3 py-2'
          onClick={handleScheduleCall}
        >
          Schedule a call
        </button>
      </div>

      {/* Description */}
      <div className='mt-7 text-left'>
        <p className='card-description'>
          Ecomnext with additional custom <br /> features
        </p>
      </div>

      {/* Horizontal Rule */}
      <hr className='custom-card-horizontal-rule' />

      {/* Features Heading */}
      <div>
        <h4 className='custom-card-feature-heading'>Professional +</h4>
      </div>

      {/* Features List */}
      <ul className='custom-card-feature-list'>
        {[
          'Data storage solution',
          'Tailored software solution',
          'Product Availability',
          'Solution specialist',
          'Exclusive assistance service',
        ].map((feature, index) => (
          <li key={index} style={{ display: 'flex', alignItems: 'center' }}>
            <span
              style={{
                color: 'green',
                fontSize: '15px',
                marginRight: '8px',
              }}
            >
              ✔
            </span>
            {feature}
          </li>
        ))}
      </ul>
    </div>
  );
};

CustomPlanCard.propTypes = {
  // savePremiumSubDetails: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {})(CustomPlanCard);
